import React from 'react'
import { useState } from 'react';
import { Input, Radio } from 'antd';
import { Collapse, Checkbox, Button } from 'antd';
import { AiOutlineRight } from "react-icons/ai";

const { Panel } = Collapse;
const { TextArea } = Input;
const { Search } = Input;
interface OptionType {
  label: string;
  value: string;
}
const CreateSubscription = () => {
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [disabled, setDisabled] = useState(true);

  const handleChange = (value: string[]) => {
    setSelectedItems(value);
  };



  const options: OptionType[] = [
    { label: 'Punjab', value: 'Punjab' },
    { label: 'Haryana', value: 'Haryana' },
    { label: 'Delhi', value: 'Delhi' },
    { label: ' Jmmu-Kasmir', value: 'Jmmu-Kasmir' },
    { label: 'Rajsthan', value: 'Rajsthan' },
    { label: 'Mumbai', value: 'Mumbai' },
    { label: 'Karnatak', value: 'Karnatak' },
    { label: 'Uttar-pradsh', value: 'Uttar-pradsh' },
    { label: 'Banglore', value: 'Banglore' },
    { label: 'Mumbai', value: 'Mumbai' },
    { label: 'Karnatak', value: 'Karnatak' },
    { label: 'Uttar-pradsh', value: 'Uttar-pradsh' },
    { label: 'Banglore', value: 'Banglore' },
  ];

  const cityOptions: OptionType[] = [
    { label: 'Ludhiana', value: 'Ludhiana' },
    { label: 'Chandigarh', value: 'Chandigarh' },
    { label: 'Amritsar', value: 'Amritsar' },
    { label: 'Gurugram', value: 'Gurugram' },
    { label: 'Faridabad', value: 'Faridabad' },
    { label: 'New Delhi', value: 'New Delhi' },
    { label: 'Srinagar', value: 'Srinagar' },
    { label: 'Jammu', value: 'Jammu' },
    { label: 'Jaipur', value: 'Jaipur' },
    { label: 'Udaipur', value: 'Udaipur' },
    { label: 'Mumbai', value: 'Mumbai' },
    { label: 'Pune', value: 'Pune' },
    { label: 'Bangalore', value: 'Bangalore' },
    { label: 'Mysore', value: 'Mysore' },
    { label: 'Lucknow', value: 'Lucknow' },
    { label: 'Kanpur', value: 'Kanpur' },
    { label: 'Hyderabad', value: 'Hyderabad' },
    { label: 'Chennai', value: 'Chennai' },
];


  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );


  return (
    <>
      <section >
        <div className='Create-Category'>

          <h3>Create Subscription</h3>
          <div className='subscription'>
            <div className='subscription-plan'>
              <label htmlFor="">Subscription Plan Display Name <span className='required'>*</span></label>
              <Input size='large' placeholder="LPL Prime-Basic Plan" />
            </div>
            <div className='subscription-plan'>
              <label htmlFor="">Plan Tenure in Months <span className='required'>*</span></label>
              <Input size='large' placeholder="3" />
            </div>
          </div>

          <div className='select_city'>
            <div className='state-accordion'>
              <label htmlFor="">State <span className='required'>*</span></label>
              <div className='city-accordion'>
                <Collapse accordion>
                  <Panel header="Select State" key="1">
                    <div className="checkbox-grid">
                      {options.map((option) => (
                        <div key={option.value} className="checkbox-item">
                          <Checkbox
                            checked={selectedItems.includes(option.value)}
                            onChange={(e) => {
                              const newValue = e.target.checked
                                ? [...selectedItems, option.value]
                                : selectedItems.filter((item) => item !== option.value);
                              setSelectedItems(newValue);
                            }}
                          >
                            {option.label}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Panel>

                </Collapse>
              </div>

            </div>
            <div className='state-accordion'>

              <label htmlFor="">City <span className='required'>
                *</span></label>
              <div className='city-accordion'>
                <Collapse accordion>
                  <Panel header="Select City" key="1">
                    <div className="checkbox-grid">
                      {cityOptions.map((option) => (
                        <div key={option.value} className="checkbox-item">
                          <Checkbox
                            checked={selectedItems.includes(option.value)}
                            onChange={(e) => {
                              const newValue = e.target.checked
                                ? [...selectedItems, option.value]
                                : selectedItems.filter((item) => item !== option.value);
                              setSelectedItems(newValue);
                            }}
                          >
                            {option.label}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Panel>

                </Collapse>
              </div>

            </div>


          </div>

          <div className="select-applicable-test">
            <label htmlFor="">Please Select Applicable Tests</label>
            <div className='applivable-test-radio'>
              <Radio defaultChecked disabled={disabled}>
                <label htmlFor=""> All Tests</label>
              </Radio>
              <Radio defaultChecked disabled={disabled}>
                <label htmlFor="">All Packages</label>
              </Radio>
              <Radio >
                <label htmlFor="">Custom</label>

              </Radio>
            </div>


          </div>

          <div className='select-tests'>
            <label htmlFor=""> Select Tests</label>
            <div className='select-test-accordion'>
              <Collapse accordion>
                <Panel header="Enter Test Code" key="1">
                  <div className='search-test'>
                    <Search
                      placeholder="Search Test Code"
                      onChange={(e) => setSearchTerm(e.target.value)}
                      value={searchTerm}
                    />
                  </div>
                  <div className="checkbox-grid">
                    {filteredOptions.map((option) => (
                      <div key={option.value} className="checkbox-item">
                        <Checkbox
                          checked={selectedItems.includes(option.value)}
                          onChange={(e) => {
                            const newValue = e.target.checked
                              ? [...selectedItems, option.value]
                              : selectedItems.filter((item) => item !== option.value);
                            setSelectedItems(newValue);
                          }}
                        >
                          {option.label}
                        </Checkbox>
                      </div>
                    ))}
                  </div>
                </Panel>

              </Collapse>
            </div>
          </div>

          <div className='select-benefits' >
            <label htmlFor="">Select Others Benefits</label>

            <div className='benefit-accordion-1'>
              <Collapse accordion>
                <Panel header="Benefits" key="1">
                  <div className="checkbox-grid">
                    {options.map((option) => (
                      <div key={option.value} className="checkbox-item">
                        <Checkbox
                          checked={selectedItems.includes(option.value)}
                          onChange={(e) => {
                            const newValue = e.target.checked
                              ? [...selectedItems, option.value]
                              : selectedItems.filter((item) => item !== option.value);
                            setSelectedItems(newValue);
                          }}
                        >
                          {option.label}
                        </Checkbox>
                      </div>
                    ))}
                  </div>
                  <div className='bottom-button'>
                    <div style={{ padding: '10px' }}>
                      <Button type="primary" onClick={() => console.log(selectedItems)}>
                        Save & Proceed

                        <span>
                          <AiOutlineRight />

                        </span>
                      </Button>
                    </div>
                  </div>
                </Panel>

              </Collapse>
            </div>

            <div className='benefit-accordion-2 '>
              <Collapse accordion>
                <Panel header="Discounts" key="1">
                  <div>
                    <div className='discount'>
                      <div className="discount-applied">
                        <label htmlFor="">Discount to be applied</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Flat</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">%age</label>
                          </Radio>

                        </div>
                      </div>

                      <div className='flat-discount '>
                        <label htmlFor="">Flat Discount to be Provided </label>
                        <Input size='large' placeholder="10" />
                      </div>
                    </div>

                    <div className='discount'>
                      <div className='flat-discount '>
                        <label htmlFor="">Maximum Discount </label>
                        <Input size='large' placeholder="500" />
                      </div>
                      <div className='flat-discount '>
                        <label htmlFor="">Minimum Cart Value</label>
                        <Input size='large' placeholder="1" />
                      </div>
                    </div>
                    <div className='discount'>
                      <div className='flat-discount '>
                        <label htmlFor="">Benefit Description to be Visible at Front End </label>
                        <Input size='large' placeholder="10% discount on every orders" />
                      </div>
                      <div className='flat-discount '>
                        <label htmlFor="">Limit Per Mobile Number</label>
                        <Input size='large' placeholder="30" />
                      </div>
                    </div>

                    <div className='discount'>
                      <div className='flat-discount '>
                        <label className='frequency' htmlFor="">Frequency
                          <div className='frequency-plus'>+</div>
                        </label>
                        <Input size='large' placeholder="2" />
                      </div>
                      <div className="discount-applied">
                        <label htmlFor="">Frequency Duration</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Day</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Week</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Month</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Plan Duration</label>
                          </Radio>

                        </div>
                      </div>
                    </div>

                    <div className='discount'>
                      <div className='flat-discount '>

                        <label className='frequency' htmlFor="">Frequency
                          <div className='frequency-plus'>+</div>
                        </label>
                        <Input size='large' placeholder="5" />
                      </div>
                      <div className="discount-applied">
                        <label htmlFor="">Frequency Duration</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Day</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Week</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Month</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Plan Duration</label>
                          </Radio>

                        </div>
                      </div>
                    </div>





                  </div>

                </Panel>

              </Collapse>
            </div>
            <div className='benefit-accordion-3 '>
              <Collapse accordion>
                <Panel header="Swasth Points" key="1">
                  <div>
                    <div className='discount'>
                      <div className="discount-applied">
                        <label htmlFor="">Swasth Points To Be Credited <span className='required'>*</span></label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Flat</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">%age</label>
                          </Radio>

                        </div>
                      </div>

                      <div className='flat-discount '>
                        <label htmlFor="">%Age Swasth Points To Be Provided <span className='required'>*</span> </label>
                        <Input size='large' placeholder="10" />
                      </div>
                    </div>

                    <div className='discount'>
                      <div className='flat-discount '>
                        <label htmlFor="">Maximum Points </label>
                        <Input size='large' placeholder="500" />
                      </div>
                      <div className='flat-discount '>
                        <label htmlFor="">Minimum Cart Value</label>
                        <Input size='large' placeholder="1" />
                      </div>
                    </div>
                    <div className='discount'>
                      <div className='flat-discount '>
                        <label htmlFor="">Benefit Description to be Visible at Front End </label>
                        <Input size='large' placeholder="10% discount on every orders" />
                      </div>
                      <div className='flat-discount '>
                        <label htmlFor="">Limit Per Mobile Number</label>
                        <Input size='large' placeholder="30" />
                      </div>
                    </div>

                    <div className='discount'>
                      <div className='flat-discount '>
                        <label className='frequency' htmlFor="">Frequency
                          <div className='frequency-plus'>+</div>
                        </label>
                        <Input size='large' placeholder="2" />
                      </div>
                      <div className="discount-applied">
                        <label htmlFor="">Frequency Duration</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Day</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Week</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Month</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Plan Duration</label>
                          </Radio>

                        </div>
                      </div>
                    </div>

                    <div className='discount'>
                      <div className='flat-discount '>

                        <label className='frequency' htmlFor="">Frequency
                          <div className='frequency-plus'>+</div>
                        </label>
                        <Input size='large' placeholder="5" />
                      </div>
                      <div className="discount-applied">
                        <label htmlFor="">Frequency Duration</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Day</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Week</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Month</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Plan Duration</label>
                          </Radio>

                        </div>
                      </div>
                    </div>





                  </div>

                </Panel>

              </Collapse>
            </div>
            <div className='benefit-accordion-4 '>
              <Collapse accordion>
                <Panel header="Free Diet Counselling  " key="1">
                  <div>
                    <div className='discount'>
                      <div className='flat-discount '>
                        <label htmlFor="">No. of Free Diet Counselling</label>
                        <Input size='large' placeholder="3" />
                      </div>

                      <div className='flat-discount '>
                        <label htmlFor="">Benefit Description to be Visible at Front End <span className='required'>* </span></label>
                        <Input size='large' placeholder="1 free Diet Counselling per month" />
                      </div>
                    </div>




                    <div className='discount'>
                      <div className='flat-discount '>
                        <label className='frequency' htmlFor="">Frequency

                        </label>
                        <Input size='large' placeholder="1" />
                      </div>
                      <div className="discount-applied">
                        <label htmlFor="">Frequency Duration</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Day</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Week</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Month</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Plan Duration</label>
                          </Radio>

                        </div>
                      </div>
                    </div>
                  </div>

                </Panel>

              </Collapse>
            </div>

            <div className='benefit-accordion-5 '>
              <Collapse accordion>
                <Panel header="Free Doctor Consultation" key="1">
                  <div>
                    <div className='discount'>
                      <div className='flat-discount '>
                        <label htmlFor="">No. of Free Doctor Consulation </label>
                        <Input size='large' placeholder="3" />
                      </div>

                      <div className='flat-discount '>
                        <label htmlFor="">Benefit Description to be Visible at Front end <span className='required'>*</span> </label>
                        <Input size='large' placeholder="1 free Doctor consultation every month - Total 3 free consultations." />
                      </div>
                    </div>

                    <div className='discount'>
                      <div className='flat-discount '>
                        <label className='frequency' htmlFor="">Frequency

                        </label>
                        <Input size='large' placeholder="2" />
                      </div>
                      <div className="discount-applied">
                        <label htmlFor="">Frequency Duration</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Day</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Week</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Month</label>
                          </Radio>


                        </div>
                      </div>
                    </div>
                    <div className='discount'>
                      <div className='flat-discount '>
                        <label htmlFor="">No. of Free Doctor Consulation </label>
                        <Input size='large' placeholder="3" />
                      </div>

                      <div className='flat-discount '>
                        <label htmlFor="">Benefit Description to be Visible at Front end <span className='required'>*</span> </label>
                        <Input size='large' placeholder="1 free Doctor consultation every month - Total 3 free consultations." />
                      </div>
                    </div>




                    <div className='discount'>
                      <div className='flat-discount '>

                        <label className='frequency' htmlFor="">Frequency

                        </label>
                        <Input size='large' placeholder="5" />
                      </div>
                      <div className="discount-applied">
                        <label htmlFor="">Frequency Duration</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Day</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Week</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Month</label>
                          </Radio>


                        </div>
                      </div>
                    </div>





                  </div>

                </Panel>

              </Collapse>
            </div>
            <div className='benefit-accordion-6 '>
              <Collapse accordion>
                <Panel header="Free Home Collection" key="1">
                  <div>
                    <div className='discount'>
                      <div className='flat-discount '>
                        <label htmlFor="">No. of Free Home Collection </label>
                        <Input size='large' placeholder="3" />
                      </div>

                      <div className='flat-discount '>
                        <label htmlFor="">Benefit Description to be Visible at Front end <span className='required'>*</span> </label>
                        <Input size='large' placeholder="3 Free Home Collections (1 per month) for low cart value orders." />
                      </div>
                    </div>

                    <div className='discount'>
                      <div className='flat-discount '>
                        <label className='frequency' htmlFor="">Frequency

                        </label>
                        <Input size='large' placeholder="1" />
                      </div>
                      <div className="discount-applied">
                        <label htmlFor="">Frequency Duration</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Day</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Week</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Month</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Plan Duration</label>
                          </Radio>


                        </div>
                      </div>
                    </div>
                  </div>

                </Panel>

              </Collapse>
            </div>

            <div className='benefit-accordion-7 '>
              <Collapse accordion>
                <Panel header="Free Smart Report" key="1">
                  <div>
                    <div className='discount'>
                      <div className='flat-discount '>
                        <label htmlFor="">No. of Free Home Collection </label>
                        <Input size='large' placeholder="3" />
                      </div>

                      <div className='flat-discount '>
                        <label htmlFor="">Benefit Description to be Visible at Front end <span className='required'>*</span> </label>
                        <Input size='large' placeholder="3 Free Home Collections (1 per month) for low cart value orders." />
                      </div>
                    </div>

                    <div className='discount'>
                      <div className='flat-discount '>
                        <label className='frequency' htmlFor="">Frequency

                        </label>
                        <Input size='large' placeholder="1" />
                      </div>
                      <div className="discount-applied">
                        <label htmlFor="">Frequency Duration</label>
                        <div className='applivable-test-radio'>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor=""> Day</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Week</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Month</label>
                          </Radio>
                          <Radio defaultChecked disabled={disabled}>
                            <label htmlFor="">Plan Duration</label>
                          </Radio>


                        </div>
                      </div>
                    </div>
                  </div>

                </Panel>

              </Collapse>
            </div>
          </div>

          <div className='additional-comment'>
            <label htmlFor="">Additional Comments</label>
            <div>
              <TextArea rows={4} placeholder="Add Comments" />
            </div>
          </div>

          <div className='bottom-button'>
            <div style={{ padding: '10px' }}>
              <Button type="primary" onClick={() => console.log(selectedItems)}>
                Save & Proceed

                <span>
                  <AiOutlineRight />

                </span>
              </Button>
            </div>
          </div>

        </div>
      </section>


    </>
  )
}


export default CreateSubscription